import { useEffect } from "react";
import { useState } from "react";
import "./RecognitionLayout.scss";

const address = "ws://" + window.location.hostname + ":10503";

function RecognitionLayout() {
	const [webSocketMessages, webSocketState] = useWebSocketMessages();
	return (
		<div className='main'>
			<div className='connection'>
				{`• Статус соединения:`}
				<div
					className={
						webSocketState === 1
							? "succesfull"
							: webSocketState === 0
							? "closed"
							: "failed"
					}
				>
					{webSocketState === 1
						? "Соединение установлено"
						: webSocketState === 0
						? "Соединение закрыто"
						: "Ошибка соединения"}
				</div>{" "}
			</div>
			<div className='messages'>
				{webSocketMessages.map((item, i) => {
					return <div key={i}>{`○ ${item.message}`}</div>;
				})}
			</div>
		</div>
	);
}

const useWebSocketMessages = () => {
	const [webSocketMessages, setWebSocketMessages] = useState([]);
	const [webSocketState, setWebSocketState] = useState(0);
	useEffect(() => {
		const wsConnection = new WebSocket(address);
		wsConnection.onopen = () => {
			console.log("WS opened");
			setWebSocketState(1);
		};
		wsConnection.onclose = () => {
			console.log("WS closed");
			setWebSocketState(0);
		};
		wsConnection.onerror = () => {
			console.log("WS error");
			setWebSocketState(-1);
		};
		wsConnection.onmessage = (event) => {
			console.log(JSON.parse(event.data));
			setWebSocketMessages((prev) => {
				let arr = [...prev];
				arr.push(JSON.parse(event.data));
				return arr;
			});
		};
	}, []);
	return [webSocketMessages, webSocketState];
};

export default RecognitionLayout;
